
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
// import { OrderServiceStage, ViewType } from '@/types/orderServicer';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import SelectParts from '../order/components/OrderParts.vue';
import OrderTag from '../order/components/OrderTag.vue';
import OrderBrand from '../order/components/OrderBrand.vue';
import OrderDevice from '@/components/DeviceSelectDialog/index.vue';
import InputDialog from '@/components/InputDialog/InputDialog.vue';
import SelectFaultDialog from '@/components/SelectFaultDialog/index.vue';
import { getOrderTaskDetail, taskSendRepair, taskRemote, taskVisit, taskJiXiu, taskTransfer, taskFinish, taskCooperate, orderTaskCheck } from '@/api/orderTask';
import { getPriceList } from '@/api/other';
import { addAddress, getAddress } from '@/api/address';
import { addImage, addPrice, addRemark, addVideo, addWord, deleteDevice, deleteFault, deleteImage, deleteParts, deletePrice, deleteProduct, deleteRemark, deleteVideo, deleteWord, handleTags } from '@/api/order';
import { getDepartmentList } from '@/api/company';

import { makeKey } from '@/utils/qiniu';
import { imageType } from '@/types/imageType';
import { remarkType } from '@/types/remarkType';
import { limit } from '@/types/limit';
import { isEmpty, parseTime } from '@/utils';
import { getWorkUser } from '@/api/users';
import { checkPermissionUseAndCompany, getModelPermission, checkTaskAppointmentTimeIsMust, checkPermissionCompanyFromOrderType } from '@/utils/permission';
import { ModuleType, ViewType, Type } from '../../types/permissionType';
import { regular } from '@/const/regular';
import OrderArea from '../order/components/OrderArea.vue';
import { Loading } from 'element-ui';
import { LoadingServiceOptions } from 'element-ui/types/loading';
import { addAppointmentTime, diyContent } from '@/api/orderService';

@Component({
  name: 'TaskTodeal',
  components: {
    DialogImgLarge,
    SelectParts,
    OrderTag,
    OrderBrand,
    OrderDevice,
    OrderArea,
    InputDialog,
    SelectFaultDialog
  }
})
export default class extends Vue {
  private limit:any = limit;

  private appointmentimeMust=false;
  private formInformation: any = {
    ordernumber: '',
    customer: '',
    task: '',
    tag: '',
    brand: '',
    brandStr: '',
    devices: '',
    parts: [],
    appointmentime: '',
    troubleImg: [],
    troubleVideo: [],
    image: [],
    video: [],
    word: [],

    isUrgent: '',

    costType: '',
    costValue: '',
    faultTypeParent: '',
    faultType: '',
    remark: '',
    fixSum: '',
    dealMan: '',
    dealDep: '',
    dealType: '',
    dealTime: ''
  }
  private dynamicRemark:any = []
  private dynamicFault:any = []
  private dynamicCost:any = []
  private faultList:any = []
  private faultList2:any = []
  private costList:any = []
  private partsVisible = false
  private tagVisible =false
  private servicer:any={}
  private deviceId = ''
  private deviceVisible = false

  private selectTagArray:any = [];
  private selectDevice:any = [];

  private companyId = '';
  private taskId = '';
  private orderType = '';
  private taskDetail: any = {
    order: {}
  };
  private taskHandleType: any = {};
  private taskHandleSpecific: any = {};
  private modulesHandlePer: any = {};
  private permissionType = Type;
  private activeAssignName = 'SongXiu'
  private enterType = ''; // 1 立即处理 2 协同处理 3 追加信息 4 任务完成

  // private listLoading = false
  // // hud loading
  // private arraySpanMethod(IOrderColspan:any) {
  //   if (IOrderColspan.columnIndex === 0) {
  //     return [1, 8];
  //   } else {
  //     return [0, 0];
  //   }
  // }
  private created() {
    // 接收传值
    // (this.$route.query.taskDetail as any).order_task.company_id;
    // this.taskId = (this.$route.query.taskDetail as any).order_task.id;
    this.companyId = this.$route.query.companyId as any;
    this.taskId = this.$route.query.taskId as any;
    this.orderType = this.$route.query.orderType as any;
    this.enterType = this.$route.query.enterType as any;
    // 任务详情 配置权限
    this.getTaskDetail();
    this.configPermission();
  }

  // private haveVisitTime = false;
  private configPermission() {
    // 任务处理方式  工程师能否处理  九大模块处理  相关处理权限
    this.taskHandleStylePer();
    this.taskSpecificHandle();
    this.modulePerHandle();
    // let config = getFixBaseModel(this.companyId, ModuleType.TASK_VISIT);
    // this.haveVisitTime = config.visittime_config === '1';
  }
  // 根据权限 确认任务的处理方式
  private taskHandleStylePer() {
    // 任务总体处理权限 公司有权限便显示
    let songXiu = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_SONGXIU, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_SONGXIU);
    let remote = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_REMOTE, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_REMOTE);
    let visit = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_VISIT, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_VISIT);
    let jiXiu = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_SEND, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_SEND);
    let transfer = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_TRANSFER, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_TRANSFER);
    let cooperate = checkPermissionCompanyFromOrderType(this.companyId, this.permissionType.TASK_COORDINATION, this.orderType) && checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_COORDINATION);

    this.taskHandleType = {
      'songXiu': songXiu,
      'remote': remote,
      'visit': visit,
      'jiXiu': jiXiu,
      'transfer': transfer,
      'cooperate': cooperate
    };
    // 不同任务处理权限下  需要确认tab的首选 所以需要设置 activeAssignName
    if (this.taskHandleType.songXiu) this.activeAssignName = 'SongXiu';
    else if (this.taskHandleType.remote) this.activeAssignName = 'Remote';
    else if (this.taskHandleType.visit) this.activeAssignName = 'Visit';
    else if (this.taskHandleType.jiXiu) this.activeAssignName = 'JiXiu';
    else if (this.taskHandleType.transfer) this.activeAssignName = 'Transfer';
    else if (this.taskHandleType.cooperate) this.activeAssignName = 'Cooperate';

    // 如果是协同处理 那么首选 Cooperate
    if (this.taskHandleType.cooperate && this.enterType === '2') this.activeAssignName = 'Cooperate';

    //  如果有对应权限 并且是立即处理  或者 协同处理进入  初始请求处理
    if (this.taskHandleType.jiXiu && this.enterType === '1') {
      this.getSendRepairAddressList();
    }
    if (this.taskHandleType.transfer && this.enterType === '1') {
      this.getTransferDepsLists(1);
    }
    if (this.taskHandleType.cooperate || this.enterType === '1' || this.enterType === '2') {
      this.getCooperateDepsLists(1);
    }
  }

  // 工程师具体处理任务权限
  private taskSpecificHandle() {
    let songXiu1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_SONGXIU);
    let remote1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_REMOTE);
    let visit1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_VISIT);
    let jiXiu1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_SEND);
    let transfer1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_TRANSFER);
    let cooperate1 = checkPermissionUseAndCompany(this.companyId, this.permissionType.TASK_COORDINATION);

    this.taskHandleSpecific = {
      'songXiu': songXiu1,
      'remote': remote1,
      'visit': visit1,
      'jiXiu': jiXiu1,
      'transfer': transfer1,
      'cooperate': cooperate1
    };
  }

  // 九大模块的权限判断
  private modulePerHandle() {
    let tag = this.setPermissionWithType(ModuleType.ORDER_TAG);
    let brand = this.setPermissionWithType(ModuleType.ORDER_PRODUCT);
    let device = this.setPermissionWithType(ModuleType.ORDER_DEVICE);
    let part = this.setPermissionWithType(ModuleType.ORDER_PARTS);
    let img = this.setPermissionWithType(ModuleType.ORDER_DEAL_IMAGE);
    let video = this.setPermissionWithType(ModuleType.ORDER_DEAL_VIDEO);
    let fee = this.setPermissionWithType(ModuleType.ORDER_COST);
    let fault = this.setPermissionWithType(ModuleType.ORDER_FAULTTYPE);
    let remark = this.setPermissionWithType(ModuleType.ORDER_REMARK);
    let fixSummary = this.setPermissionWithType(ModuleType.ORDER_FIX_SUMMARY);

    let diyOne = this.setPermissionWithType(ModuleType.ORDER_DIY_ONE);
    let diyTwo = this.setPermissionWithType(ModuleType.ORDER_DIY_TWO);
    let word = this.setPermissionWithType(ModuleType.ORDER_WORD_FILE);

    this.modulesHandlePer = {
      'tag': tag,
      'brand': brand,
      'device': device,
      'part': part,
      'img': img,
      'video': video,
      'fee': fee,
      'fault': fault,
      'remark': remark,
      'fixSummary': fixSummary,
      'diyOne': diyOne,
      'diyTwo': diyTwo,
      'word': word
    };
  }

  private setPermissionWithType(moduleType: ModuleType) {
    return getModelPermission(ViewType.DEAL_TASK, this.orderType, 0, this.companyId, moduleType);
  }

  // 切换tab点击事件  注意寄修 转派 协同数据的处理
  private tabClick(tab: any, event: any) {
    // if (this.activeAssignName === 'JiXiu') {
    //   this.getSendRepairAddressList();
    // } else if (this.activeAssignName === 'Transfer') {
    //   this.getDepartmentList(1);
    // } else if (this.activeAssignName === 'Cooperate') {
    //   this.getDepartmentList(1);
    // }
  }
  /**
   * 点击完成  确认任务处理
  */
  private confirmTaskHandle() {
    if (this.enterType !== '1') {
      if (!this.judgeMoudlesInputInfo()) {
        return;
      }
    }

    if (this.activeAssignName === 'SongXiu') {
      this.handleSongXiu();
    } else if (this.activeAssignName === 'Remote') {
      this.handleRemote();
    } else if (this.activeAssignName === 'Visit') {
      this.handleVisit();
    } else if (this.activeAssignName === 'JiXiu') {
      this.handleJiXiu();
    } else if (this.activeAssignName === 'Transfer') {
      this.handleTransfer();
    } else if (this.activeAssignName === 'Cooperate') {
      this.handleCooperate();
    }
  }

  /**
   *  任务 服务完成
  */
  private taskFinishClick() {
    if (this.needCheckTask()) {
      this.handleCheck();
      return;
    }
    if (!this.judgeMoudlesInputInfo()) {
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: (this.taskDetail as any).order_task.id,
      fix_summary: this.formInformation.fixSum,
      is_quote_order: '0' // 生成报价单
    };
    taskFinish(params).then(res => {
      this.showSuccessMsg('服务完成');
      setTimeout(() => {
        this.backToTaskList();
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 送修
  private handleSongXiu() {
    if (!this.taskHandleSpecific.songXiu) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.companyId;
    params.order_task_id = this.taskId;
    taskSendRepair(params).then(res => {
      this.showSuccessMsg('送修成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.handleNextTask(data.dispose_next);
      } else {
        this.backToTaskList();
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 远程
  private handleRemote() {
    if (!this.taskHandleSpecific.remote) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.companyId;
    params.order_task_id = this.taskId;
    taskRemote(params).then(res => {
      this.showSuccessMsg('远程处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.handleNextTask(data.dispose_next);
      } else {
        this.backToTaskList();
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 上门
  private handleVisit() {
    if (!this.taskHandleSpecific.visit) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    if ((!this.formInformation.appointmentime || parseInt(this.formInformation.appointmentime) === 0) && this.appointmentimeMust) {
      this.showErrorMsg('请选择预约时间');
      return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.companyId;
    params.order_task_id = this.taskId;
    // params.visit_time = parseTime(this.formDoor.doorTime, '{y}-{m}-{d} {h}:{i}:{s}');
    taskVisit(params).then(res => {
      this.showSuccessMsg('上门处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.handleNextTask(data.dispose_next);
      } else {
        this.backToTaskList();
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 预约时间添加
  private appointmentChange(val:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      order_service_id: this.taskDetail.order_service.id,
      order_id: this.taskDetail.order.id,
      servicer_appointment_time: val / 1000 };
    addAppointmentTime(pamars).then(res => {
      this.getTaskDetail();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  /**
   * 寄修处理
  */
  private regular = regular;
  private rules= {
    name: [
      {
        pattern: regular.userName.pattern,
        message: '请输入2-10位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ],
    address: [
      { required: true, message: '请输入2-50个字符组成的地址', trigger: 'blur' },
      {
        pattern: regular.address.pattern,
        message: '请输入2-50个字符组成的地址',
        trigger: 'blur'
      }
    ],
    mobile: [
      {
        pattern: regular.mobile.pattern,
        message: '请输入正确格式的手机号码',
        trigger: 'blur'
      }
    ],
    phone_num: [
      {
        pattern: regular.phone.pattern,
        message: '请输入3-18位电话号码',
        trigger: 'blur'
      }
    ]
  }
  private formAddress = {
    name: '',
    mobile: '',
    phone_num: '',
    address: '',
    province: '',
    city: '',
    province_name: '',
    city_name: '',
    district: '',
    district_name: '',
    latitude: '',
    longitude: '',
    adcode: '',
    zip_code: ''
  }
  private addressList: any = []

  // 获取寄修地址
  private getSendRepairAddressList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    getAddress(params).then(res => {
      const data = res.data;
      if (data) {
        this.addressList = data.list;
      } else {
        this.addressList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 选择收货地址
  private handleReciveStaffAddress(val: any, index: any) {
    for (let i = 0; i < this.addressList.length; i++) {
      if (i !== index) {
        this.addressList[i].isActive = false;
      }
    }
    val.isActive = true;
    this.formAddress = val;
  }
  // 新增收货地址
  private dialogAddAddressVisible = false
  private formAddAddress: any = {
    name: '',
    address: '',
    mobile: '',
    telephone: '',
    area: '',
    province: '',
    city: '',
    district: ''
  }
  private addNewAddress() {
    this.dialogAddAddressVisible = true;
  }
  // 省市区 选择
  private areaVisible = false;
  private selectAreaHandle() {
    this.areaVisible = true;
  }
  private closeAreaHandle() {
    this.areaVisible = false;
  }
  private saveAreaHandle(val: any) {
    this.formAddAddress.province = val.province_name;
    this.formAddAddress.city = val.city_name;
    this.formAddAddress.district = val.district_name;
    this.formAddAddress.adcode = val.adcode;
    this.formAddAddress.area = val.province_name !== val.city_name
      ? val.province_name + '  ' + val.city_name + '  ' + val.district_name
      : val.province_name + '  ' + val.district_name;
    this.areaVisible = false;
  }
  private clickToAddAddress() { // 先判断此处编辑是否符合规则
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.addAddressRequest();
      } else {
        return false;
      }
    });
  }
  private addAddressRequest() {
    let params: any = {
      user_id: UserModule.getUserId,
      address: this.formAddAddress.address,
      name: this.formAddAddress.name,
      mobile: this.formAddAddress.mobile,
      phone_num: this.formAddAddress.telephone,
      province_name: this.formAddAddress.province,
      city_name: this.formAddAddress.city,
      district_name: this.formAddAddress.district,
      adcode: this.formAddAddress.adcode
    };
    addAddress(params).then(res => {
      this.showSuccessMsg('添加成功');
      this.dialogAddAddressVisible = false;
      this.getSendRepairAddressList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 寄修处理
  private handleJiXiu() {
    if (!this.taskHandleSpecific.jiXiu) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    if (this.formAddress.address.length === 0) {
      this.showErrorMsg('请选择收货地址');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      send_name: this.formAddress.name,
      send_mobile: this.formAddress.mobile,
      send_phone: this.formAddress.phone_num,
      send_address: this.formAddress.address,
      send_province: this.formAddress.province,
      send_province_name: this.formAddress.province_name,
      send_city: this.formAddress.city,
      send_city_name: this.formAddress.city_name,
      send_district: this.formAddress.district,
      send_district_name: this.formAddress.district_name,
      send_latitude: this.formAddress.latitude,
      send_longitude: this.formAddress.longitude,
      send_adcode: this.formAddress.zip_code
      // send_adcode: this.formAddress.adcode
    };
    taskJiXiu(params).then(res => {
      this.showSuccessMsg('寄修处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.handleNextTask(data.dispose_next);
      } else {
        this.backToTaskList();
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 转派加载更多
private depttransferPageCount: any = 1;
  private depttransferPage: any = 1;
  private depttransferMore() {
    this.depttransferPage = this.depttransferPage + 1;
    this.getTransferDepsLists(this.depttransferPage);
  }
  private engtransferPageCount: any = 1;
  private engtransferPage: any = 1;
  private engtransferMore() {
    this.engtransferPage = this.engtransferPage + 1;
    this.getTransferEngs(this.engtransferPage, this.selecttransferDep);
  }
  private transferDeps: any = [];
  private selecttransferDep:any={};
  private transferEngs: any = [];
  // 转派 获取部门
  private getTransferDepsLists(page: any) {
    let params: any = {
      page: page,
      type: 2,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      size: 999
    };
    getDepartmentList(params).then(res => {
      const data = res.data;
      if (data) {
        if (this.deptPage === 1) {
          this.transferDeps = data.list;
          for (let index = 0; index < this.transferDeps.length; index++) {
            this.transferDeps[index].isDark = 'plain';
          }
          this.transferDeps[0].isDark = 'dark';
          // 有隶属部门  再请求工程师列表
          const department: any = this.transferDeps[0];
          if (department.id !== '0') {
            this.selecttransferDep = department;
            this.getTransferEngs(1, department);
          }
        } else {
          this.transferDeps = this.transferDeps.concat(data.list);
        }
        this.deptPageCount = data.page_count;
      } else {
        this.transferDeps = [];
        this.deptPageCount = 1;
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 转派 部门切换
  private selectTransferHandle(val: any) {
    for (let index = 0; index < this.transferDeps.length; index++) {
      this.transferDeps[index].isDark = 'plain';
    }
    val.isDark = 'dark';
    this.engtransferPage = 1;
    this.selecttransferDep = val;
    this.getTransferEngs(1, val);
  }
  //  转派 获取工程师
  private getTransferEngs(page: any, val: any) {
    let params: any = {
      page: page,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      dept_id: val.id,
      dept_name: val.name
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    getWorkUser(params).then(res => {
      const data = res.data;
      if (data) {
        if (this.engtransferPage === 1) {
          this.transferEngs = data.list;
        } else {
          this.transferEngs = this.transferEngs.concat(data.list);
        }
        this.engtransferPageCount = data.page_count;
      } else {
        this.engtransferPageCount = 0;
        this.transferEngs = [];
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 转派  选择工程师
  private checkedEngineer: any = {};
  private formTransfer: any = {};
  private selectEngineer(val: any) {
    this.formTransfer = val;
  }
  // 转派  发送请求
  private handleTransfer() {
    if (!this.taskHandleSpecific.transfer) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    if (!this.formTransfer.dept_id) {
      this.showErrorMsg('请选择转派工程师');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      work_dept_name: this.formTransfer.dept_name,
      work_dept_id: this.formTransfer.dept_id,
      work_user_name: this.formTransfer.user.name,
      work_user_id: this.formTransfer.user.id
    };
    taskTransfer(params).then(res => {
      this.showSuccessMsg('转派处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.handleNextTask(data.dispose_next);
      } else {
        this.backToTaskList();
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private deptPageCount: any = 1;
  private deptPage: any = 1;
  private deptMore() {
    this.deptPage = this.deptPage + 1;
    this.getCooperateDepsLists(this.deptPage);
  }
  private engiPageCount: any = 1;
  private engiPage: any = 1;
  private engiMore() {
    this.engiPage = this.engiPage + 1;
    this.getCooperateEngs(this.engiPage, this.selectedDep);
  }
  private cooperateDeps: any = []
  private cooperateEngs: any = []
  private selectedDep: any = {}
  private dynamicAssignchecked: any = []
  private currentAssignchecked: any = []
  private assignchecked: any = []
  // 协同 获取部门
  private getCooperateDepsLists(page: any) {
    let params: any = {
      page: page,
      type: 2,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId
    };
    getDepartmentList(params).then(res => {
      const data = res.data;
      if (data) {
        if (this.deptPage === 1) {
          this.cooperateDeps = data.list;
          // 有隶属部门  再请求工程师列表
          const department: any = this.cooperateDeps[0];
          if (department.id !== '0') {
            this.selectedDep = department; // 协同处理默认选中第一个部门
            this.getCooperateEngs(1, department);
          }
        } else {
          this.cooperateDeps = this.cooperateDeps.concat(data.list);
        }
        this.deptPageCount = data.page_count;
      } else {
        this.cooperateDeps = [];
        this.deptPageCount = 1;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 协同部门切换
  private selectDept() {
    // 切换部门之前 保存之前选中的数据
    if (this.dynamicAssignchecked.length === 0) {
      this.assignchecked = [];
    }
    this.dynamicAssignchecked = this.dynamicAssignchecked.concat(this.currentAssignchecked);
    this.dynamicAssignchecked = this.dynamicAssignchecked.filter(function(item: any, index: any, arr: any) {
      return arr.indexOf(item, 0) === index;
    });
    this.engiPage = 1;
    this.getCooperateEngs(1, this.selectedDep);
  }
  // 协同 获取工程师
  private getCooperateEngs(page: any, val: any) {
    let params: any = {
      page: page,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      dept_id: val.id,
      dept_name: val.name
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    getWorkUser(params).then(res => {
      const data = res.data;
      if (data) {
        if (this.engiPage === 1) {
          this.cooperateEngs = data.list;
        } else {
          this.cooperateEngs = this.cooperateEngs.concat(data.list);
        }
        this.engiPageCount = data.page_count;

        let _this = this;
        let currentArr: any = [];
        for (let index = 0; index < _this.cooperateEngs.length; index++) {
          for (let m = 0; m < _this.dynamicAssignchecked.length; m++) {
            // 我这个条件估计不对, 换成正确的条件 再测测
            if ((_this.cooperateEngs[index] as any).user.id === (_this.dynamicAssignchecked[m] as any).user.id) {
              _this.$nextTick(function() {
                currentArr.push(_this.cooperateEngs[index]);
                this.assignchecked = currentArr;
              });
            }
          }
        }
      } else {
        this.engiPageCount = 0;
        this.cooperateEngs = [];
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 协同  顶部 删除已经选择的协同人员标签
  private handleCloseAssign(v: any) {
    let index = this.assignchecked.indexOf(v);
    if (index !== -1) {
      this.assignchecked.splice(index, 1);
    }
    let _index = this.dynamicAssignchecked.indexOf(v);
    if (_index !== -1) {
      this.dynamicAssignchecked.splice(_index, 1);
    }
    let ctIndex = this.currentAssignchecked.indexOf(v);
    if (ctIndex !== -1) {
      this.currentAssignchecked.splice(ctIndex, 1);
    }
  }
  // 协同 选中工程师
  private assigncheckedChange(val: any) {
    this.currentAssignchecked = val;
    this.dynamicAssignchecked = this.currentAssignchecked;
  }
  // 协同 发送请求
  private handleCooperate() {
    if (!this.taskHandleSpecific.cooperate) {
      this.$confirm('您没有处理任务的权限', '提示', {
        confirmButtonText: '知道了',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.backToTaskList();
      });
      return;
    }
    if (this.assignchecked.length === 0) {
      this.showErrorMsg('请选择协同工程师');
      return;
    }
    if (this.assignchecked.length > 10) {
      this.showErrorMsg('最多选择10个工程师');
      return;
    }
    // 考虑去重问题
    var engineers: any = [];
    for (const item of this.assignchecked) {
      let engineer = {
        dept_name: item.dept_name,
        dept_id: item.dept_id,
        name: item.user.name,
        user_id: item.user.id
      };
      engineers.push(engineer);
    }
    let engineerStr = JSON.stringify(engineers);
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      work_user: engineerStr
    };
    taskCooperate(params).then(res => {
      this.showSuccessMsg('协同处理成功');
      setTimeout(() => {
        this.backToTaskList();
      }, 1 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 点击继续处理下一个任务
  private handleNextTask(val: any) {
    this.$confirm('要继续处理下一个任务吗?', '提示', {
      confirmButtonText: '继续处理',
      cancelButtonText: '取消',
      showClose: false,
      type: 'info'
    }).then(() => {
      let option : LoadingServiceOptions = { text: '加载中' };
      let loadingInstance = Loading.service(option);
      setTimeout(() => {
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          this.companyId = val.company_id;
          this.taskId = val.id;
          this.orderType = val.order_type;
          this.enterType = '1';
          this.getTaskDetail();
          this.configPermission();
          loadingInstance.close();
        });
      }, 1 * 1000);
    }).catch(() => {
      this.backToTaskList();
    });
  }

  // 点击返回 返回到任务列表
  private backToTaskList() {
    this.$router.go(-1);
  }

  // 获取任务详情
  private getTaskDetail() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId
    };
    getOrderTaskDetail(params).then(res => {
      const data = res.data;
      if (data) {
        this.taskDetail = data;
        this.qiniu = this.taskDetail.uptoken;
        this.formInformation.ordernumber = data.order.order_num;
        this.formInformation.customer = data.order.customer_company_name ? data.order.customer_company_name : data.order.customer_user_name +
        '\n ' + data.order.name + '  ' + (data.order.mobile || data.order.phone_num) +
        '\n ' + data.order.province_name + data.order.city_name + data.order.district_name + data.order.address;
        this.formInformation.task = data.order.trouble_describle;
        this.formInformation.troubleImg = data.order.trouble_image_list;
        this.formInformation.troubleVideo = data.order.video_list;

        // 处理信息
        if (this.enterType === '4') {
          this.formInformation.dealMan = data.order_task.user_name;
          this.formInformation.dealDep = data.order_task.dept_name;

          let dealType = data.order_task.deal_type;
          this.formInformation.dealType = dealType === '1' ? '远程' : dealType === '2' ? '上门' : dealType === '3' ? '寄修' : dealType === '4' ? '转单' : '送修';
          this.formInformation.dealTime = parseTime(data.order_task.deal_time, '{y}-{m}-{d} {h}:{i}:{s}');
        }

        // 预约时间
        if (data.order_service.servicer_appointment_timestamp && parseInt(data.order_service.servicer_appointment_timestamp) !== 0) {
          this.formInformation.appointmentime = data.order_service.servicer_appointment_timestamp + '000';
        }
        // 标签 tag
        this.selectTagArray = data.order.tags ? data.order.tags : [];

        // 品牌
        let brandInfoModel: any = data.order.order_brand;
        if (brandInfoModel) {
          let brandStr = '';
          brandStr = this.isNull(brandInfoModel.brand_name) +
          '/' + this.isNull(brandInfoModel.product_name) +
          '/' + this.isNull(brandInfoModel.model_name);
          this.formInformation.brandStr = brandStr;
          this.formInformation.brand = brandInfoModel;
        }
        // 设备
        let deviceArr = data.order.order_device;
        this.selectDevice = deviceArr;
        // 备件
        let partsArr = data.order.parts_list;
        if (partsArr) {
          for (const item of partsArr) {
            item.str = this.partsInfo(item);
          }
        }
        this.formInformation.parts = partsArr;
        // 图片
        let imgArr = data.order.order_image;
        this.formInformation.image = imgArr;
        // 视频
        let videoArr = data.order_service.video_list;
        if (videoArr) {
          for (var item of videoArr) {
            item.img_url = item.full_path;
          }
          this.formInformation.video = videoArr;
        } else {
          this.formInformation.video = []
        }
        if (data.order_service.document_list) {
          this.formInformation.word = data.order_service.document_list;
        } else {
          this.formInformation.word = [];
        }
        if (this.formInformation.word) {
          this.formInformation.word.map(function(item:any) {
            item.name = item.original_name;
          });
        }
        // 费用列表  故障类型 备注
        this.dynamicCost = data.order.order_price;
        this.dynamicFault = data.order.fault_list;
        this.dynamicRemark = data.order.order_remark;
        // 审核判断
        this.configCheck();
        this.appointmentimeMust = checkTaskAppointmentTimeIsMust(this.taskDetail.order.order_type, this.companyId);
      }
      // else {
      //   this.formInformation = {};
      // }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  /**
   * 审核处理
  */
  private configCheck() {
    if (this.needCheckTask()) this.handleCheck();
  }
  private needCheckTask() {
    let priceLimit = this.taskDetail.order.order_check_price_limit;
    if (priceLimit) {
      var totalPrice = 0.0;
      if (this.dynamicCost) {
        for (const item of this.dynamicCost) {
          totalPrice += parseFloat(item.price_num);
        }
      }
      if (this.formInformation.parts) {
        for (const item of this.formInformation.parts) {
          totalPrice += parseFloat(item.parts_price);
        }
      }
      if (this.taskDetail.order.check_state !== '71' && totalPrice >= parseFloat(priceLimit)) return true;
    }
    return false;
  }
  private checkModel: any = {
    remark: '',
    title: ''
  }
  private checkVisible = false;
  private handleCheck() {
    let priceLimit = this.taskDetail.order.order_check_price_limit;
    // let tip = '金额超过' + priceLimit + '元, 请提交审核';
    let tip = '您的订单金额超过限制，请提交审核！';
    this.checkVisible = true;
    this.checkModel.title = tip;
  }
  private clickToCancleCheck() {
    this.checkVisible = false;
  }
  private clickToCheck() {
    if (!this.checkModel.remark) {
      this.showErrorMsg('请填写提审备注');
      return;
    }
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      order_service_id: (this.taskDetail as any).order_service.id,
      order_check_is_price: 1,
      remark: this.checkModel.remark
    };
    orderTaskCheck(params).then(res => {
      this.showSuccessMsg('提审成功');
      setTimeout(() => {
        this.backToTaskList();
      }, 0.8 * 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // =========================
  // ================九大模块处理
  // ================
  // 订单标签
  private selectTag() {
    if (parseInt(this.taskDetail.order.order_check_tag_is_pass) === 1) {
      if (this.$refs.inputTag) {
        (this.$refs.inputTag as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    if (
      this.formInformation.tags &&
      this.formInformation.tags.length >= limit.ORDER_SERVICE_ADD_TAG
    ) {
      this.showErrorMsg('您最多选择' + limit.ORDER_SERVICE_ADD_TAG + '个标签');
      return;
    }
    this.tagVisible = true;
  }

  private closeTagHandle(val:boolean) {
    this.tagVisible = val;
  }

  private delTagHandle(val: any) {
    if (parseInt(this.taskDetail.order.order_check_tag_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    let tags: any = [];
    tags = tags.concat(this.selectTagArray);
    tags.splice(tags.indexOf(val), 1);
    let values: any = [];
    for (const item of tags) {
      let tag: any = {};
      tag.tags_name = item.tags_name;
      tag.tags_id = item.tags_id;
      values.push(tag);
    }
    let tagsValue = values.length > 0 ? JSON.stringify(values) : '';
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      tags: tagsValue
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    handleTags(params)
      .then((res: any) => {
        this.showSuccessMsg('标签删除成功');
        this.selectTagArray.splice(this.selectTagArray.indexOf(val), 1);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private confirmTagHandle(value:any) {
    this.tagVisible = false;
    this.showSuccessMsg('标签添加成功');
    this.selectTagArray.push(value);
  }

  // 品牌
  private brandVisible = false
  private selectBrandHandle() {
    this.brandVisible = true;
  }
  private closeBrandHandle(val: boolean) {
    this.brandVisible = val;
  }
  private confirmBrandHandle(val:any) {
    this.brandVisible = false;
    this.showSuccessMsg('添加成功');
    this.formInformation.brandStr =
      this.isNull(val.brand_name) +
      '/' + this.isNull(val.product_name) +
       '/' + this.isNull(val.model_name);
    this.formInformation.brand = val;
  }

  private deleteBrandHandle(id: any) {
    const params: any = {
      id: id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteProduct(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.formInformation.brand = '';
        this.formInformation.brandStr = '';
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 设备选择
  private selectDeviceHandle() {
    this.deviceVisible = true;
  }
  private closeDeviceHandle(val: boolean) {
    this.deviceVisible = val;
  }

  private cleanDevice(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteDevice(params)
      .then((res: any) => {
        this.showSuccessMsg('设备删除成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private confirmDeviceHandle(value: any) {
    this.deviceVisible = false;
    this.showSuccessMsg('设备添加成功');
    // 因为没有返回新生成记录的ID  所以直接重新调用任务详情
    this.getTaskDetail();
  }

  // 选择备件
  private selectPartsHandle() {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      if (this.$refs.inputParts) {
        (this.$refs.inputParts as any).blur();
      }
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    this.partsVisible = true;
  }
  private closeParts(val:boolean) {
    this.partsVisible = val;
  }
  private deletePartsHandle(val:any) {
    if (val.already_charge_off_num && parseInt(val.already_charge_off_num) !== 0) {
      this.showErrorMsg('备件已核销不能删除');
      return;
    }
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private confirmParts(val:any) {
    this.partsVisible = false;
    // 因为没有返回新生成记录的ID  所以直接重新调用任务详情
    this.getTaskDetail();
    // val.str = this.partsInfo(val);
    // this.formInformation.parts.push(val);
  }

  // 添加费用处理
  // 点击费用类型input  获取费用列表  @focus
  private costItemVisibility = false
  private priceClick() {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    this.costItemVisibility = true;
  }
  // 获取费用类表
  private getPrice() {
    if (this.costList.length === 0) {
      const params = {
        user_id: UserModule.getUserId,
        company_id: this.companyId
      };
      getPriceList(params)
        .then((res: any) => {
          this.costList = res.data.list;
        })
        .catch((err: any) => {
          this.showErrorMsg(err.msg);
        });
    }
  }
  // 费用选中 设置金额
  private selectCost(val: any) {
    this.formInformation.costValue = val.price_num;
  }

  // 添加费用
  private addCostHandle(type: any, cost: any) {
    if (!type) {
      this.showErrorMsg('请选择费用类型');
      return;
    }
    var temp = {
      price_id: type.id,
      price_name: type.price_name,
      price_num: cost
    };
    var arr = [];
    arr.push(temp);
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      price: JSON.stringify(arr)
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addPrice(params)
      .then((res: any) => {
        this.showSuccessMsg('添加成功');
        this.costItemVisibility = false;
        this.getTaskDetail();
        this.formInformation.costValue = '';
        this.formInformation.costType = '';
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除费用
  private removeCostHandle(val:any) {
    if (parseInt(this.taskDetail.order.order_check_price_is_pass) === 1) {
      this.$alert('', '此订单已通过审核，不能修改', {
        confirmButtonText: '我知道了',
        center: true,
        callback: action => {

        }
      });
      return;
    }
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deletePrice(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加故障类型
  private faultItemVisibility:any = false;
  private comfirmSelectFault(val:any) {
    this.faultItemVisibility = val;
    this.getTaskDetail();
  }
  private closeSelectFaultDialog(val:any) {
    this.faultItemVisibility = val;
  }
  private removeFaultHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteFault(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        let index = this.dynamicFault.indexOf(v);
        if (index !== -1) {
          this.dynamicFault.splice(index, 1);
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 备注处理
  // 添加备注 自定义 弹窗
  private inputDialogVisibility = false
  private inputDialogEnterType:number=0;
  private inputDialogContent:string=''

  private inputDialogComfirmHandle(val:string, val2:any) {
    switch (this.inputDialogEnterType) {
      case 0:
        if (isEmpty(val.trim())) {
          this.showErrorMsg('请填写备注');
          return;
        }
        this.addRemark(val, val2);
        break;
      case 1:
        this.addDiy(val, 'diy_one_content');
        break;
      case 2:
        this.addDiy(val, 'diy_two_content');
        break;
    }
  }
  private inputDialogClose(val:boolean) {
    this.inputDialogVisibility = val;
  }

  private remarkAddHandle() {
    this.inputDialogContent = '';
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = 0;
  }
  private addRemark(remark:string, val:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      remark_type: remarkType.ORDER_TASK_DISPOSE,
      remark: remark
    };
    if (val && val.id) {
      params.classify_id = val.id;
      params.classify_name = val.name;
    }
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addRemark(params)
      .then((res: any) => {
        this.showSuccessMsg('添加成功');
        this.inputDialogVisibility = false;
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除备注
  private removeRemarkHandle(v: any) {
    const params: any = {
      id: v.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteRemark(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        let index = this.dynamicRemark.indexOf(v);
        if (index !== -1) {
          this.dynamicRemark.splice(index, 1);
        }
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 自定义
  private diyOneAddHandle(val:number) {
    if (val === 1) {
      this.inputDialogContent = this.taskDetail.order.diy_one_content;
    } else {
      this.inputDialogContent = this.taskDetail.order.diy_two_content;
    }
    this.inputDialogVisibility = true;
    this.inputDialogEnterType = val;
  }
  private addDiy(content:string, field:string) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      edit_value: content,
      edit_field: field
    };
    if (this.taskDetail.order) {
      params.order_id = this.taskDetail.order.id;
    }
    if (this.taskDetail.order_service) {
      params.order_service_id = this.taskDetail.order_service.id;
    }
    if (this.taskDetail.order_task) {
      params.order_task_id = this.taskDetail.order_task.id;
    }
    diyContent(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.inputDialogVisibility = false;
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加图片成功  此处注意image_type
  private qiniu: any;
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private form: object = {};
  private defaultUrl = '';

  // 上传图片
  private handleUploadImgSuccess(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      save_path: val.key,
      image_type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addImage(params)
      .then((res: any) => {
        this.showSuccessMsg('图片上传成功');
        let img : any = {
          id: res.data.id,
          img_url: this.qiniu.default_url + val.key,
          image: val.key
        };
        this.getTaskDetail();
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(err.msg);
      });
  }

  // 删除图片
  private deleteImgHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteImage(params)
      .then((res: any) => {
        this.showSuccessMsg('图片删除成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传图片准备
  private beforeUploadImg(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 ' +
      limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + 'MB!');
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: this.companyId
    };
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 上传视频
  private handleUploadSuccessVideo(val: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      save_path: val.key,
      video_type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    addVideo(params)
      .then((res: any) => {
        // this.formInformation.video.push({
        //   id: res.data.id,
        //   full_url: this.qiniu.default_url + val.key,
        //   image: val.key
        // });
        this.showSuccessMsg('视频上传成功');
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 删除视频
  private deleteVideoHandle(val: any) {
    const params: any = {
      id: val.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteVideo(params)
      .then((res: any) => {
        this.showSuccessMsg('视频删除成功');
        this.formInformation.video.splice(this.formInformation.video.indexOf(val), 1);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 上传视频准备
  private beforeUploadUploadVideo(file: any) {
    const isJPG = file.type === 'video/mp4';
    const isLt2M = file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  mp4 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 ' +
       limit.ORDER_SERVICE_ADD_VIDEO_MAX_SIZE + 'MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey) + '.mp4';
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  // 文档
  private uploadSuccessDocument(res:any, file:any, fileList:any) {
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id,
      type: imageType.ORDER_TASK_IMG_DISPOSE
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    let arr = [];
    arr.push({
      original_name: file.name,
      save_path: res.key
    });
    params.document = JSON.stringify(arr);
    addWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private beforeUploadDocument(file:any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }
  private onExceed() {
    this.$message.error('最多上传4个文档');
  }
  private onRemove(file:any, fileList:any) {
    const params: any = {
      id: file.id,
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_task_id: this.taskId,
      order_id: (this.taskDetail as any).order.id
    };
    if ((this.taskDetail as any).order_service) {
      params.order_service_id = (this.taskDetail as any).order_service.id;
    }
    deleteWord(params)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.getTaskDetail();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private assignFormSearch = {
    dept: '',
    area: ''
  }

  private judgeMoudlesInputInfo() {
    if (this.modulesHandlePer.tag.m === 1 && (!this.selectTagArray || this.selectTagArray.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.tag.me);
      return false;
    }
    if (this.modulesHandlePer.brand.m === 1 && (!this.formInformation.brand || this.formInformation.brand.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.brand.me);
      return false;
    }
    if (this.modulesHandlePer.device.m === 1 && (!this.selectDevice || this.selectDevice.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.device.me);
      return false;
    }
    if (this.modulesHandlePer.part.m === 1 && (!this.formInformation.parts || this.formInformation.parts.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.part.me);
      return false;
    }
    if (this.modulesHandlePer.img.m === 1 && (!this.formInformation.image || this.formInformation.image.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.img.me);
      return false;
    }
    if (this.modulesHandlePer.video.m === 1 && (!this.formInformation.video || this.formInformation.video.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.video.me);
      return false;
    }
    if (this.modulesHandlePer.word.m === 1 && (!this.formInformation.word || this.formInformation.word.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.word.me);
      return false;
    }
    if (this.modulesHandlePer.fee.m === 1 && (!this.dynamicCost || this.dynamicCost.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.fee.me);
      return false;
    }
    if (this.modulesHandlePer.fault.m === 1 && (!this.dynamicFault || this.dynamicFault.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.fault.me);
      return false;
    }
    if (this.modulesHandlePer.remark.m === 1 && (!this.dynamicRemark || this.dynamicRemark.length === 0)) {
      this.showErrorMsg(this.modulesHandlePer.remark.me);
      return false;
    }
    if (this.modulesHandlePer.fixSummary.m === 1 && (!this.formInformation.fixSum || isEmpty(this.formInformation.fixSum.trim()))) {
      this.showErrorMsg(this.modulesHandlePer.fixSummary.me);
      return false;
    }
    if (this.modulesHandlePer.diyOne.m === 1 && !this.taskDetail.order.diy_one_content) {
      this.showErrorMsg(this.modulesHandlePer.diyOne.me);
      return false;
    }
    if (this.modulesHandlePer.diyTwo.m === 1 && !this.taskDetail.order.diy_two_content) {
      this.showErrorMsg(this.modulesHandlePer.diyTwo.me);
      return false;
    }
    return true;
  }

  private isNull(val:any) {
    if (val) {
      return val;
    } else {
      return '~';
    }
  }

  private partsInfo(val: any) {
    let str = this.isNull(val.parts_name) +
              '/' + this.isNull(val.parts_model_name) +
              '/' + this.isNull(val.parts_amount) +
              '/' + this.isNull(val.parts_unit_price) +
              '/' + this.isNull(val.parts_price) +
              '/' + this.isNull(val.parts_attribute_name);
    return str;
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
